import type { Form } from '@piccolohealth/pbs-common';
import { ChakraV3, Spin } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';
import { FaPlus } from 'react-icons/fa';
import { FormSection } from '../../components/forms/FormSection';
import { FormStack } from '../../components/forms/FormStack';
import { showModal } from '../../components/generic/Modal';
import { PiccoloError } from '../../components/generic/PiccoloError';
import { useFormsQuery } from '../../graphql/hooks/useFormsQuery';
import { useAppContext } from '../../hooks/useAppContext';
import { usePermission } from '../../hooks/usePermission';
import { FormCard } from './forms/FormCard';
import { FormCreateModal } from './forms/FormCreateModal';

export const FormSettings = () => {
  const { organization } = useAppContext();
  const { isLoading, data, error } = useFormsQuery({
    organizationId: organization.id,
  });

  const forms = data?.organization?.forms as Form[];

  const createFormPermission = usePermission('create', 'form');

  if (isLoading) {
    return <Spin />;
  }

  if (error) {
    return <PiccoloError error={error} />;
  }

  return (
    <FormSection
      heading='Forms'
      description='Your forms to share on social media, messaging apps or via email.'
      maxW='lg'
    >
      <ChakraV3.Separator />
      <FormStack mb={6}>
        <ChakraV3.Wrap gap={4} w='full'>
          {P.isEmpty(forms) && <ChakraV3.Text fontSize='sm'>No forms added yet</ChakraV3.Text>}
          {forms.map((form) => (
            <ChakraV3.WrapItem key={form.id} w='full'>
              <FormCard form={form} />
            </ChakraV3.WrapItem>
          ))}
        </ChakraV3.Wrap>
        <ChakraV3.Button
          onClick={() => showModal(FormCreateModal)}
          disabled={!createFormPermission}
          w='fit-content'
          size='sm'
          colorPalette='brand'
        >
          <FaPlus />
          Create new form
        </ChakraV3.Button>
      </FormStack>
    </FormSection>
  );
};
